// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.print_report[data-v-71f192c6] {\n  width: 82%;\n  margin: 0 auto;\n}\n.print_reporttzbs[data-v-71f192c6] {\n  width: 100%;\n  margin: 0 auto;\n}\n/*@media print {*/\n/*  @page {*/\n/*    !* 纵向 *!*/\n/*    !* 边距 上右下左 *!*/\n/*    margin: 1cm 2cm 1cm 2cm;*/\n/*  }*/\n\n/*  .print_reporttzbs {*/\n/*    width: 100%;*/\n/*    margin: 0 auto;*/\n/*    text-align: left;*/\n/*  }*/\n/*}*/\n", ""]);
// Exports
module.exports = exports;
